export default {
  example: {
    test: 'Language Test'
  },
  placeholder: {
    select: 'Please select',
    input: 'Please enter',
    upload: 'Please upload'
  },
  correct: {
    email: 'Please enter the correct email address',
    phone: 'Please enter an valid phone No.',
  }
}